import Alert from '@components/modals/alert/alert';
export default Alert;
